import { createPortal, useRef } from 'preact/compat'
import Icon from '@/components/snippets/icon/icon'

export const SearchHeader = ({ query, totalResults, isLoading, corrections }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  const focusSearch = (containerId) => {
    const searchContainer = document.querySelector(`#${containerId} input[name="query"]`)
    if (searchContainer) {
      setTimeout(() => {
        searchContainer.focus()
      }, 100)
    }
  }

  return createPortal(
    !isLoading && (
      <div className="flex flex-col md:justify-end gap-x-gutter gap-y-1 w-full" data-results={totalResults}>
        <h2 className="h3 font-semibold w-full">
            {totalResults === 0 ? 'No' : totalResults} Results For "{corrections?.corrected ? corrections?.corrected : query}"
        </h2>
        {corrections?.corrected && (
            <div className="paragraph-s">
                <p>No results found for "{query}". Showing results for "{corrections.corrected}" instead.</p>
            </div>
        )}
        {corrections?.didYouMean && (
            <div className="paragraph-s">
                <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} className='link-fade' aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
            </div>
        )}
        {totalResults === 0 && !isLoading && (
            <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
        )}
        <x-button class="!hidden lg:!flex btn btn-primary btn-fill btn-m btn-bold w-fit" data-modal-parent="quick-search-desktop" data-modal-role="open" aria-label="Search Again Desktop" onClick={() => focusSearch('quick-search-desktop')}>
          <div className="flex size-[17px] children:size-full">
            <Icon id="magnifying-glass" />
          </div>
          Search Again
        </x-button>
        <x-button class="lg:!hidden btn btn-primary btn-fill btn-m btn-bold w-fit" data-modal-parent="quick-search-mobile" data-modal-role="open" aria-label="Search Again Mobile" onClick={() => focusSearch('quick-search-mobile')}>
          <div className="flex size-[17px] children:size-full">
            <Icon id="magnifying-glass" />
          </div>
          Search Again
        </x-button>
      </div>
    ), searchHeader
  )
}
